import { v4 } from "uuid";
import { api } from "../api";

export const createScenarioFromScratch = async ({
  customerId,
  isAutomation = false,
  automationTriggerType,
  newTemplate,
  newTemplateName,
}) => {
  let whatsappTemplateName = newTemplateName ?? "";
  let parameters = {};
  let headerText = null;
  let bodyText = null;
  let footerText = null;
  let body = null;
  let replyButtons = [];
  let urlButton;
  let copyCodeButton = null;
  let limitedTimeOffer = null;
  let cards = null;

  if (newTemplate) {
    newTemplate.components.forEach((c) => {
      if (c.type === "HEADER") {
        if (c.format === "IMAGE") {
          parameters = {
            ...parameters,
            header: {
              type: "image",
              image: {
                // link: customerId.isCloudApi ? "" : c.example?.header_handle[0],
                link: "",
              },
            },
          };
        } else if (c.format === "VIDEO") {
          parameters = {
            ...parameters,
            header: {
              type: "video",
              video: {
                // link: customerId.isCloudApi ? "" : c.example?.header_handle[0],
                link: "",
              },
            },
          };
        } else if (c.format === "TEXT" && c.example) {
          parameters = {
            ...parameters,
            header: {
              type: "text",
              text: c.example.text ?? "",
            },
          };
        }
      } else if (c.type === "BODY") {
        // Trouver tous les {{n}} dans le texte
        const matches = c.text.match(/{{(\d+)}}/g) || [];

        // Trouver le plus grand nombre
        const maxIndex = Math.max(
          ...matches.map((m) => parseInt(m.replace(/[{}]/g, ""), 10)),
          0,
        );

        // Générer le tableau
        parameters = {
          ...parameters,
          body:
            maxIndex > 0
              ? Array.from({ length: maxIndex }, () => ({
                  type: "text",
                  selected: "contact.whatsappName",
                }))
              : null,
        };
      }

      headerText =
        newTemplate.components?.find(
          (c) => c.format === "TEXT" && c.type === "HEADER",
        )?.text ?? "";
      bodyText =
        newTemplate.components?.find((c) => c.type === "BODY")?.text ?? "";
      footerText =
        newTemplate.components?.find((c) => c.type === "FOOTER")?.text ?? "";
      body = `${headerText ? headerText + "\n\n" : ""}${
        bodyText ? bodyText + "\n\n" : ""
      }${footerText}`;
    });

    replyButtons = newTemplate.components
      ?.find((c) => c.type === "BUTTONS")
      ?.buttons?.filter((b) => b.type === "QUICK_REPLY")
      .map((b) => {
        return {
          create: {
            customer: { _link: customerId },
            whatsappId: v4(),
            title: b.text,
          },
        };
      });

    urlButton = newTemplate.components
      ?.find((c) => c.type === "BUTTONS")
      ?.buttons?.filter((b) => b.type === "URL");
    var officialWhatsappTemplate;
    if (urlButton && urlButton[0]) {
      officialWhatsappTemplate =
        await api.officialWhatsappTemplate.maybeFindFirst({
          filter: {
            name: { equals: whatsappTemplateName },
            customerId: { equals: customerId },
          },
          select: {
            id: true,
            buttonUrlLink: true,
            buttonUrlLink2: true,
          },
        });
    }
  }

  if (
    newTemplate?.components?.find((c) => c.type === "LIMITED_TIME_OFFER")
      ?.limited_time_offer
  ) {
    limitedTimeOffer = {
      expirationDate: undefined,
      expirationDelayInMinutes: undefined,
      expirationType: "delay",
      text: newTemplate?.components?.find(
        (c) => c.type === "LIMITED_TIME_OFFER",
      )?.limited_time_offer.text,
    };
    copyCodeButton = newTemplate.components
      ?.find((c) => c.type === "BUTTONS")
      ?.buttons?.find((b) => b.type === "COPY_CODE");
  }

  if (newTemplate?.components?.find((c) => c.type === "CAROUSEL")?.cards) {
    cards = newTemplate?.components?.find((c) => c.type === "CAROUSEL")?.cards;
    let officialWhatsappTemplate =
      await api.officialWhatsappTemplate.maybeFindFirst({
        filter: {
          customerId: { equals: customerId },
          name: { equals: newTemplateName },
        },
        select: {
          id: true,
          urlButtonsInCards: true,
          buttonUrlLink: true,
          buttonUrlLink2: true,
        },
      });
    let officialButtons;
    if (officialWhatsappTemplate?.urlButtonsInCards) {
      officialButtons = officialWhatsappTemplate.urlButtonsInCards;
    }
    cards = cards.map((card, index) => {
      const headerComponent = card.components.find((c) => c.type === "HEADER");
      const bodyComponent = card.components.find((c) => c.type === "BODY");
      const buttonsComponent = card.components.find(
        (c) => c.type === "BUTTONS",
      );

      const matchingUrlButtons = officialButtons?.find(
        (item) => item.cardIndex === index,
      );
      let btnIndex = 0;
      const updatedButtons =
        buttonsComponent?.buttons.map((button) => {
          if (
            (button.type === "URL" || button.type === "url") &&
            button.url.includes("redirect")
          ) {
            const newUrl =
              matchingUrlButtons?.buttons?.[btnIndex]?.url || button.url;
            btnIndex++;

            return {
              ...button,
              url: newUrl,
            };
          }
          return button;
        }) || [];
      const bodyText = bodyComponent?.text || "";
      const paramMatches = bodyText.match(/{{\d+}}/g);
      const bodyParameters = paramMatches
        ? paramMatches.map(() => ({
            type: "text",
            selected: `contact.whatsappName`,
          }))
        : [];

      return {
        components: [
          {
            type: "HEADER",
            format: headerComponent?.format === "IMAGE" ? "IMAGE" : "VIDEO",
            link: "",
          },
          {
            type: "BODY",
            text: bodyComponent?.text || "",
            bodyParameters: bodyParameters.length > 0 ? bodyParameters : null,
          },
          {
            type: "BUTTONS",
            buttons: updatedButtons || [],
          },
        ],
      };
    });
  }

  const whatsappTemplate = await api.whatsappTemplate.create({
    whatsappTemplate: {
      customer: { _link: customerId },
      whatsappTemplateName: whatsappTemplateName,
      headerParameters: parameters?.header,
      bodyParameters: parameters?.body,
      buttonParameters: parameters?.buttons,
      copyCode: copyCodeButton?.example[0],
      limitedTimeOfferText: limitedTimeOffer?.text,
      expirationType: limitedTimeOffer?.expirationType,
      expirationDate: limitedTimeOffer?.expirationDate,
      expirationDelayInMinutes: limitedTimeOffer?.expirationDelayInMinutes,
      cards: cards,
      campaign: {
        create: {
          customer: { _link: customerId },
          trigger: isAutomation ? "api" : "manual",
          name: `${isAutomation ? "Automation" : "Campaign"} title`,
          automationType: isAutomation ? automationTriggerType : null,
          scenario: {
            create: {
              type: isAutomation ? "automation" : "campaign",
              customer: { _link: customerId },
              name: `${isAutomation ? "Automation" : "Campaign"} title`,
            },
          },
        },
      },
      ...(officialWhatsappTemplate && {
        redirectionUrl: {
          create: {
            customer: { _link: customerId },
            url: officialWhatsappTemplate.buttonUrlLink,
            uuid: v4(),
          },
        },
      }),
      ...(officialWhatsappTemplate &&
        officialWhatsappTemplate?.buttonUrlLink2 && {
          redirectionUrl2: {
            create: {
              customer: { _link: customerId },
              url: officialWhatsappTemplate.buttonUrlLink2,
              uuid: v4(),
            },
          },
        }),
    },
  });

  const campaign = await api.campaign.findFirst({
    filter: {
      whatsappTemplateId: { equals: whatsappTemplate.id },
    },
    select: {
      id: true,
      scenario: {
        id: true,
      },
    },
  });

  const urlButtons =
    newTemplate?.components
      ?.find((c) => c.type === "BUTTONS")
      ?.buttons?.filter((b) => b.type === "URL") || [];

  const [firstUrlButton, secondUrlButton] = urlButtons;

  const firstButtonsComponent = newTemplate?.components?.find(
    (c) => c.type === "BUTTONS",
  );
  const isUrlButtonAtBottom =
    firstButtonsComponent?.buttons?.[0]?.type !== "URL";

  const whatsappTemplateRecord = await api.whatsappTemplate.update(
    whatsappTemplate.id,
    {
      messageSkeleton: {
        create: {
          customer: { _link: customerId },
          body: body,
          imageLink: parameters?.header?.image?.link,
          videoLink: parameters?.header?.video?.link,
          replyButtons: replyButtons,
          campaign: { _link: campaign.id },
          isCampaignTrigger: true,
          urlButtonText: firstUrlButton?.text || null,
          urlButtonLink: firstUrlButton?.url || null,
          urlButtonText2: secondUrlButton?.text || null,
          urlButtonLink2: secondUrlButton?.url || null,
          isUrlButtonAtBottom: isUrlButtonAtBottom || null,
        },
      },
    },
    { select: { id: true, messageSkeleton: { id: true } } },
  );

  const whatsappTemplateNode = await api.flowNode.create({
    flowNode: {
      customer: { _link: customerId },
      positionX: isAutomation ? 204 : 0,
      positionY: 0,
      scenario: { _link: campaign.scenario.id },
      type: "whatsapp_template",
      whatsappTemplate: {
        update: {
          id: whatsappTemplateRecord.id,
        },
      },
    },
  });

  if (newTemplate) {
    for (var k = 0; k < replyButtons?.length; k++) {
      const b = replyButtons[k];
      const button = await api.replyButton.findFirst({
        filter: {
          whatsappId: { equals: b.create.whatsappId },
        },
        select: {
          id: true,
        },
      });
      await api.flowNode.create({
        flowNode: {
          customer: { _link: customerId },
          positionX: 0,
          positionY: 0,
          type: "reply_button",
          scenario: { _link: campaign.scenario.id },
          parentNode: { _link: whatsappTemplateNode.id },
          replyButton: {
            update: {
              id: button.id,
            },
          },
        },
      });
    }
  }

  if (isAutomation) {
    await api.flowNode.create({
      flowNode: {
        customer: { _link: customerId },
        positionX: 0,
        positionY: 0,
        scenario: { _link: campaign.scenario.id },
        type: "automation_trigger",
        automationTriggerType: automationTriggerType,
      },
    });
  }

  return `/${isAutomation ? "automations" : "campaigns"}/edit/${campaign.id}`;
};
